import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/SignUp/SignUp.js
const SignUp = () => <NoSettings text="Sign-up form. No settings." />;

export default SignUp;
